import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { VFC } from "react";
import styled from "styled-components";
import { Markdown } from "components";
import { useAnchor } from "hooks";
import { Title6Content } from "types/graphql/generated";
interface Props {
  className?: string;
  content: Title6Content;
}

const Title6: VFC<Props> = withErrorBoundary(({ content: { title, description } }) => {
  useAnchor("title6");

  return (
    <StyledTitle className="title6 Content">
      <h2 className="Title6__title Font_48_54_600 lg:Font_40_48_600 sm:Font_32_40_600">{title}</h2>
      <Markdown className="Title6__description Color_secondary Font_24_32_450">{description}</Markdown>
    </StyledTitle>
  );
}, {});

const StyledTitle = styled.section`
  display: flex;
  align-items: center;
  margin-top: -64px;
  padding-top: 64px;

  .Title6__title {
    width: fit-content;
    max-width: 489px;
    flex-shrink: 0;
  }

  .Title6__description {
    margin-left: 127px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.xl}px`}) {
    .Title6__description {
      margin-left: 46px;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    flex-direction: column;
    align-items: flex-start;

    .Title6__description {
      margin-left: 0;
      margin-top: 32px;
    }
  }
`;

gql`
  fragment Title6Content on ComponentTitleTitle6 {
    title
    description
  }
`;

export { Title6 };
export type { Props as Title6Props };
